import { useState, useEffect } from "react";
import {
  Box,
  Card,
  Button,
  TextField,
  Autocomplete,
  CardMedia,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseOffer } from "./UseOffer";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function OfferInformation(props) {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate2, AddOfferInformation, UpdateOfferInformation } = UseOffer();
  const [offers, setOffers] = useState();
  const headerColors = ["بدون رنگ", "primary", "secondary"];
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    id: undefined,
    aid: props.aid ? props.aid : "",
    headerColorName: null,
    productCount: undefined,
    title: undefined,
    isRotatory: false,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
  });

  useEffect(() => {
    if (props.offers) {
      setState({
        id: props.offers.id,
        aid: props.aid,
        headerColorName: props.offers.headerColorName,
        productCount: props.offers.productCount,
        title: props.offers.title,
        isRotatory: props.offers.isRotatory,
      });
      setImgState({
        file: undefined,
        url: props.offers.icon ? props.offers.icon : "",
      });
    }
  }, [props.offers]);

  const [errorState, setErrorState] = useState({
    title: false,
    productCount: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Box
      sx={{ border: "1px solid #E1E1E1", p: 2, borderRadius: 1 }}
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={2}
    >
      <Box gridColumn={isSmall ? "span 12" : "span  4"}>
        <TextField
          fullWidth
          value={state.title ? state.title : ""}
          error={errorState.title}
          label="عنوان"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, title: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span  3"}>
        <Autocomplete
          size="small"
          value={state.headerColorName ? state.headerColorName : ""}
          onChange={(event, newValue) => {
            if (newValue == "بدون رنگ") {
              setState({
                ...state,
                headerColorName: null,
              });
            } else if (newValue) {
              setState({
                ...state,
                headerColorName: newValue,
              });
            } else {
              setState({
                ...state,
                headerColorName: null,
              });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return value == "" || option === value;
          }}
          sx={{ width: isSmall ? "100%" : "80%" }}
          getOptionLabel={(option) => option}
          fullWidth
          options={headerColors}
          renderInput={(params) => (
            <TextField variant="outlined" {...params} label="رنگ هدر" />
          )}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}

      <Box
        gridColumn={isSmall ? "span 12" : "span  3"}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 5,
        }}
      >
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "50px", height: "auto" }}>
              <Card
                sx={{
                  bgcolor: imgState.url && "#d7d7d7",
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.url ? imgState.url : "/static/img/no-photos.png"
                  }
                />
              </Card>
            </Box>
          }
        />
      </Box>
      <Box gridColumn="span 9"></Box>
      <Box gridColumn={isSmall ? "span 8" : "span  3"}>
        <TextField
          value={state.productCount ? state.productCount : ""}
          error={errorState.productCount}
          label="تعداد نمایش محصول"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, productCount: evt.target.value });
          }}
          sx={{
            width: isSmall ? "100%" : "80%",
            input: {
              textAlign: "center",
            },
          }}
          type="number"
          InputProps={{
            autoComplete: "off",
            inputProps: {
              min: 1,
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      <Box gridColumn="span 9"></Box>
      <Box gridColumn={isSmall ? "span 12" : "span  6"}>
        <FormControlLabel
          checked={state.isRotatory}
          onChange={(evt) => {
            setState({ ...state, isRotatory: evt.target.checked });
          }}
          control={<Checkbox />}
          label="محصولات به صورت چرخشی نمایش داده شوند"
        />
      </Box>
      <Box gridColumn="span 6"></Box>
      <Box
        gridColumn="span 12"
        sx={{ mt: 2, display: "flex", justifyContent: "center" }}
      >
        <Button
          sx={{ mr: 2, width: "100px" }}
          variant="contained"
          onClick={() => {
            if (validate2(state, setErrorState) == 200) {
              setProgress(true);
              if (state.id == 0) {
                AddOfferInformation(state, imgState.file, (calback) => {
                  props.setOffers(calback);
                });
                return;
              } else {
                UpdateOfferInformation(state, imgState.file, (calback) => {
                  props.setOffers(calback);
                });
              }
            }
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
